import { render } from "./ExchangeHouse.vue?vue&type=template&id=6739d440&scoped=true"
import script from "./ExchangeHouse.vue?vue&type=script&lang=js"
export * from "./ExchangeHouse.vue?vue&type=script&lang=js"

import "./ExchangeHouse.vue?vue&type=style&index=0&id=6739d440&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6739d440"]])

export default __exports__